export function buildLocation(address?: Partial<{ locality: string; address: string }>): string {
    return [address?.locality, address?.address].filter(Boolean).join(', ');
}
